@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

.base {
  background-size: 800px 100%;
  animation: shimmer 1.5s ease-in-out infinite;
}

.tone-surface {
  background-image: linear-gradient(
    90deg,
    var(--md-surface-container-low) 25%,
    var(--md-surface-container) 50%,
    var(--md-surface-container-low) 75%
  );
}

.tone-onDark {
  background-image: linear-gradient(
    90deg,
    rgb(from var(--md-surface-container-lowest) r g b / 0.1) 25%,
    rgb(from var(--md-surface-container-lowest) r g b / 0.2) 50%,
    rgb(from var(--md-surface-container-lowest) r g b / 0.1) 75%
  );
}

.text {
  composes: base;
  border-radius: var(--shape-xs);
}

.size-md {
  height: 0.875rem;
}

.size-lg {
  height: 1.25rem;
}

.size-xl {
  height: 1.75rem;
}

.circle {
  composes: base;
  border-radius: 50%;
}

.rect {
  composes: base;
  border-radius: var(--shape-sm);
}
